/**
 * Research page — thesis wizard + research tools.
 *
 * v0.5.5 (AE-076): the misleading "Engineer · SIM only" badge has been
 * removed. The actual SIM/LIVE contract is now carried by the per-action
 * buttons on the page itself (Buy SIM / Buy LIVE), which is the only
 * place the routing is actually decided. Real-money orders still queue
 * to the Morning Brief for approval.
 */
import { useSearchParams } from 'react-router-dom';
import { ResearchPanel } from '../ResearchPanel';
import { ThesisWorkbenchPane } from '../ThesisWorkbenchPane';
import { PageHeader, PAGE_MAX_W } from '../PageHeader';

export function ResearchPage() {
  const [params] = useSearchParams();
  const wizard = params.get('wizard');
  // v0.5.4 AE-066: thread `?q=` into ResearchPanel.initialQuery so chat /
  // morning brief / external deeplinks land with the textarea pre-filled
  // and auto-run. Without this the URL changed but the panel stayed blank.
  const initialQuery = params.get('q') ?? undefined;

  if (wizard) {
    return (
      <div className={`${PAGE_MAX_W} mx-auto`}>
        <PageHeader
          title="Research — Thesis Wizard"
          subtitle="Analytical artifacts commit immediately. Each Buy action chooses SIM or LIVE explicitly; LIVE orders queue to the Morning Brief for approval."
        />
        <ThesisWorkbenchPane wizardId={wizard === 'new' ? undefined : wizard} />
      </div>
    );
  }

  return (
    <div className={`${PAGE_MAX_W} mx-auto`}>
      <PageHeader
        title="Research Workbench"
        subtitle="Explore themes, run thesis pipelines, and design investment theses. Each Buy action chooses SIM or LIVE explicitly; LIVE orders queue to the Morning Brief for approval."
      />
      <ResearchPanel initialQuery={initialQuery} autoRun={!!initialQuery} />
    </div>
  );
}
